import React from "react";

import {
  FormatListBulletedOutlined,
  GridOnOutlined,
} from "@mui/icons-material";
import { Box, Button, ButtonBase, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { SearchInput } from "../../common";

/* ============================================================================
  AssessmentLiveHeader
============================================================================= */
const AssessmentLiveHeader = ({
  totalAssessments,
  view,
  onViewChange,
  query,
  onSearch,
  filter,
  onFilterChange,
}) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        borderBottom="1px solid #E9EBF0"
        height="65px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        gap={2}
      >
        <Typography fontSize={"18px"} fontWeight={700}>
          My Assessments
        </Typography>
        <Button
          variant="main"
          sx={{ fontSize: "14px", fontFamily: "Outfit", fontWeight: 600 }}
          onClick={() => navigate("/assessments")}
        >
          Assessment Library
        </Button>
      </Box>

      <Box
        p={2}
        gap={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          display="flex"
          bgcolor="#F7F9FA"
          alignItems="center"
          gap={2}
          pl={2}
          borderRadius="8px"
          overflow="hidden"
        >
          <Typography fontWeight={500}>Total Assessments</Typography>
          <Typography
            sx={{
              color: "white",
              px: 3,
              py: 1.2,
              fontWeight: 600,
              bgcolor: "#9048FB",
            }}
          >
            {totalAssessments || 0}
          </Typography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={2}
        >
          <SearchInput
            placeholder="Search with name"
            value={query}
            onChange={onSearch}
            inputStyles={{ fontSize: "13px" }}
            containerStyles={{ width: { xs: "100%", md: "26rem" } }}
          />
          {/* <FilterDropDown
            value={filter}
            data={['All', 'Active', 'Expired', "Archived"]}
            placeholder="Select Stage"
            onChange={(newStage) => onFilterChange(newStage === 'All' ? null : newStage)}
          /> */}
          <Box
            border="1px solid #d1d1d1"
            height="46px"
            borderRadius="10px"
            display="flex"
          >
            {/* <ButtonBase sx={{ width: '50px', bgcolor: view === 'grid' ? '#F3E8FF' : 'transparent' }} onClick={() => onViewChange('grid')}>
              <GridOnOutlined sx={{ width: '22px', height: '22px', color: view === 'grid' ? '#9048FB' : '#4D4D4D' }} />
            </ButtonBase> */}
            <ButtonBase
              sx={{
                width: "50px",
                bgcolor: view === "list" ? "#F3E8FF" : "transparent",
              }}
              onClick={() => onViewChange("list")}
            >
              <FormatListBulletedOutlined
                sx={{
                  width: "22px",
                  height: "22px",
                  color: view === "list" ? "#9048FB" : "#4D4D4D",
                }}
              />
            </ButtonBase>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

/* Export
============================================================================= */
export default AssessmentLiveHeader;
